import type { JsonLdObject } from "@/lib/schema";

export function JsonLd({ data }: { data: JsonLdObject | JsonLdObject[] }) {
	const payload = Array.isArray(data) ? data : [data];
	return (
		<>
			{payload.map((entry, index) => (
				<script
					// biome-ignore lint/suspicious/noArrayIndexKey: stable list from head()
					key={index}
					type="application/ld+json"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD payload is serialized from trusted static data
					dangerouslySetInnerHTML={{ __html: JSON.stringify(entry) }}
				/>
			))}
		</>
	);
}
